export interface AboutContent {
  success: boolean;
  setting_key: string;
  setting_value: string;
  is_default: boolean;
  last_updated?: string;
}

export interface AboutState {
  model: AboutModel;
  loading: boolean;
  error: string | null;
  productName: string;
}

export class AboutModel {
  static initial(): AboutModel {
    return new AboutModel(null);
  }

  constructor(private data: AboutContent | null = null) {}

  static fromJSON(json: any): AboutModel {
    return new AboutModel({
      success: json.success,
      setting_key: json.setting_key,
      setting_value: json.setting_value,
      is_default: json.is_default,
      last_updated: json.last_updated
    });
  }

  get content(): string {
    return this.data?.setting_value || '';
  }

  get lastUpdated(): string | undefined {
    return this.data?.last_updated;
  }

  get isDefault(): boolean {
    return this.data?.is_default || false;
  }

  isEmpty(): boolean {
    return !this.data || !this.data.setting_value;
  }
}